import React, { createContext, useContext } from 'react';

export const SourceContext = createContext<string | undefined>(undefined);

export enum SOURCE_TYPES {
  APP = 'app',
  LIVE_CHAT = 'live_chat',
  MESSAGING = 'messaging',
  PLAYER = 'player',
}

interface ProviderProps {
  children?: React.ReactNode;
  source?: SOURCE_TYPES;
}

export const SourceContextProvider = ({
  children,
  source,
}: ProviderProps): null | JSX.Element => {
  return (
    <SourceContext.Provider value={source}>{children}</SourceContext.Provider>
  );
};

export const useSourceContext = (): string | undefined => {
  return useContext<string | undefined>(SourceContext);
};
